
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"3","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"1.5","cy":"1.5","r":"1.5","fill":"#175F69"}}),_c('circle',{attrs:{"cx":"1.5","cy":"5.5","r":"1.5","fill":"#175F69"}}),_c('circle',{attrs:{"cx":"1.5","cy":"9.5","r":"1.5","fill":"#175F69"}})])
          )
        }
      }
    